import { useCallback, useEffect, useState } from 'react';
import { projectsApi } from '@/api/projects.api';
import type { ProjectProject } from '@/types/projects';
import { showApiError } from '@/utils/apiError';

export function useProjectList() {
  const [projects, setProjects] = useState<ProjectProject[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await projectsApi.listProjects({ page: 0, size: 200 });
      setProjects(res.content);
    } catch (err) {
      showApiError(err, 'Failed to load projects');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { projects, loading, reload: load };
}
